import { Component, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { MatStepper } from '@angular/material/stepper';
import { CustomRouter } from 'src/admin-front/ajs-upgraded-providers';
import { AlcmeonContextService } from 'src/app/core/alcmeon-context/alcmeon-context.service';
import { SitesService } from 'src/app/mobile/shared/sites.service';
import { phoneNumberStepValidator } from 'src/app/parameters/add-account/whatsapp-cloud-api/whatsapp-cloud-api-pre-qualify/step-phone-number/phone-number-step.validator';
import { SiteV2 } from 'src/app/shared/models';
import { BasicService } from 'src/app/shared/services/basic.service';
import { WhatsappAccountOriginEnum } from '../shared/models/whatsapp-account-origin.enum';
import { WhatsappCloudApiLoginEventEnum } from '../shared/models/whatsapp-cloud-api-login-event.enum';
@Component({
  selector: 'app-whatsapp-cloud-api-pre-qualify',
  templateUrl: './whatsapp-cloud-api-pre-qualify.component.html',
  styleUrls: ['./whatsapp-cloud-api-pre-qualify.component.scss'],

  encapsulation: ViewEncapsulation.None,
})
export class WhatsappCloudApiPreQualifyComponent {
  migration: boolean;
  origin: WhatsappAccountOriginEnum;
  site: SiteV2;

  accountTypeControl: FormControl;
  phoneNumberGroup = this.formBuilder.group({
    phoneNumberStep: new FormControl(null, [Validators.required, phoneNumberStepValidator()]),
    migrate: this.formBuilder.group({
      agreed: new FormControl(null, Validators.required),
    }),
  });

  connectAccountGroup = this.formBuilder.group({
    localization: new FormControl(null, Validators.required),
    migrate: this.formBuilder.group({
      agreed: new FormControl(null, Validators.required),
    }),
  });
  connectAccountControl = new FormControl(null, Validators.required);
  title: string;

  WhatsappCloudApiLoginEventEnum = WhatsappCloudApiLoginEventEnum;

  @ViewChild(MatStepper) stepper: MatStepper;

  constructor(
    private formBuilder: FormBuilder,
    private alcmeonContextService: AlcmeonContextService,
    private customRouter: CustomRouter,
    basicService: BasicService,
    sitesService: SitesService
  ) {
    if (customRouter.params) {
      const { siteId, origin } = customRouter.params;
      if (siteId && origin) {
        this.site = sitesService.sitesV2Map.get(+siteId);
        this.origin = origin;
        this.migration = true;
      }
    }
    this.title = basicService.translate(
      this.migration
        ? 'add-account/whatsapp-cloud-api/migrate/title'
        : 'add-account/whatsapp-cloud-api/pre-qualify/title'
    );
    this.accountTypeControl = new FormControl(this.migration ? 2 : 1, Validators.required);
  }

  whatsappCloudApiLoginStatusChanged($event: WhatsappCloudApiLoginEventEnum) {
    if ($event === WhatsappCloudApiLoginEventEnum.CANCEL || $event === WhatsappCloudApiLoginEventEnum.ERROR) {
      this.connectAccountControl.reset();
    } else {
      this.connectAccountControl.setValue($event);
      this.stepper.next();
    }
  }

  goBack() {
    if (this.migration && this.site?.id) {
      this.customRouter.go('auth.alcmeon.fuse.account-edit', {
        companyId: this.alcmeonContextService.companyId,
        id: this.site.id,
      });
    } else {
      this.customRouter.go('auth.alcmeon.fuse.parameters.add-account', {
        companyId: this.alcmeonContextService.companyId,
      });
    }
  }
}
